module.exports = __webpack_public_path__ + "static/media/r11.31ee62b2.png";